export default __webpack_public_path__ + "resources/icons/n412-979a.png";